import { FetchApiResponse } from "redux/types";

export enum CrilicReportReduxTypes {
    CRILIC_REPORT = "@@auth/CRILIC_REPORT",
    CRILIC_REPORT_SUCCESS = "@@auth/CRILIC_REPORT_SUCCESS",
    CRILIC_REPORT_ERROR = "@@auth/CRILIC_REPORT_ERROR",
    RESET_CRILIC_REPORT = "@@auth/RESET_CRILIC_REPORT"
}

export type CrilicReportActionDispatch = {
    type: | CrilicReportReduxTypes.CRILIC_REPORT
    | CrilicReportReduxTypes.RESET_CRILIC_REPORT;
    payload: any;
}

export type CrilicReportReducerDispatch = {
    type: | CrilicReportReduxTypes.CRILIC_REPORT
    | CrilicReportReduxTypes.CRILIC_REPORT_SUCCESS
    | CrilicReportReduxTypes.CRILIC_REPORT_ERROR
    | CrilicReportReduxTypes.RESET_CRILIC_REPORT;

    payload: {
        data?: FetchApiResponse<CrilicReport>
        error?: string
    }
}

export type CrilicReport = {
    id: string,
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateCrilicReportRequest = {
    payload:{
        saveReport: boolean
    }
}
export type CreateCrilicReportSaga = {
    type: string,
    payload: CreateCrilicReportRequest
}

export type CreateCrilicReportReducerState = {
    loading ?: boolean
    data ?: {},
    error ?: string | null;
}